import ColorThief from 'colorthief/dist/color-thief.umd';

const BRANDING_BACKGROUND_OPACITY = 0.04;

export const getLogoBackgroundColor = ({
  logoUrl,
  replacementOfUrl,
}: {
  logoUrl: string;
  replacementOfUrl: (params: { url: string }) => string;
}) =>
  new Promise<string | null>((resolve) => {
    const img = new Image();
    img.addEventListener('load', () => {
      const ct = new ColorThief();
      const [r, g, b] = ct.getColor(img, 10);
      resolve(`rgba(${r}, ${g}, ${b}, ${BRANDING_BACKGROUND_OPACITY})`);
    });
    img.addEventListener('error', () => resolve(null));
    img.crossOrigin = 'anonymous';
    img.src = replacementOfUrl({ url: logoUrl });
  });
